import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Clients.css";
import CardLayout from '../../widgets/Card';
import { AudienceOptionsForm } from './AudienceOptionsForm';

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [

                { id: 'close', label: 'close', tooltip: 'close' },
                { id: 'edit', label: 'edit', tooltip: 'edit', icon: 'EditIcon' },
                { id: 'save', label: 'save', tooltip: 'save', icon: 'SaveIcon' }
                
     
            ]
        }
    ]
};

const userRef = React.createRef();

class AudienceOptions extends Component {



    handleToolbarButtonClick(buttonId) {
        if ("Add" === buttonId) {
            this.props.history.push({
                pathname: '/EmailAdd',

            })
        }
    }

    save() {
        let formValue = userRef.current.getValue();
        if (formValue !== null && typeof formValue !== 'undefined') {
            let data = JSON.stringify(formValue);
            const url = `api/indicium/provider/updateProviderDetails?data=${data}`;
            // TODO : Invoke spinner mask
            fetch(url)
                .then(res => res.json())
                .then((responseJson) => {
                    let response = JSON.parse(responseJson);
                    if (response.MessageType !== "ERROR") {
                        this.props.history.push({
                            pathname: '/EmailAddForm'
                        });
                    } else {
                        this.setState({ saveMessage: response.Message, hasSaveError: true });
                    }
                }).catch(() => {
                    this.setState({ saveMessage: "A system error has accured. Please contact your system administrator", hasSaveError: true });
                });
        }
    }

    close() {
        this.props.history.push('/EmailAddForm');
    }

    render() {
        return (
            <CardLayout title='Auddience'>
            <div className="view w-100 h-100">
                <p className="legend">
                    {"Create New"}
                </p>

                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="Audience" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    enabled={true} config={toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <AudienceOptionsForm ref={userRef}
                                    valueChangeHandler={(values) => this.handleFormValueChange(values)} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
                </CardLayout>
        );
    }
}

export default withRouter(AudienceOptions);
